import { Button, Container, Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import Iconify from '../../components/iconify'

const Unauthorized: FC = () => {
  const navigate = useNavigate()

  const goBack = () => navigate(-1)

  return (
    <Container>
      <Stack
        direction='row'
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
        <Grid container sx={{ width: '100%', mt: 10 }}>
          <Grid size={12}>
            <Button
              variant='contained'
              color='inherit'
              startIcon={<Iconify icon='eva:arrow-back-fill' />}
              onClick={goBack}
            >
              Regresar
            </Button>
          </Grid>
          <Grid size={12} sx={{ mt: 5 }}>
            <Typography variant='h4' gutterBottom>
              Acceso denegado
            </Typography>
            <Typography variant='body1' gutterBottom>
              No tienes permiso para acceder a esta página. Por favor, contacta
              al administrador del sistema si crees que esto es un error.
            </Typography>
          </Grid>
        </Grid>
      </Stack>
    </Container>
  );
}

export default Unauthorized
